import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaMenuItemModule } from '../area-menu-item/area-menu-item.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { UserInfoModule } from '../userInfo/user-info.module';
import { CenterContentComponent } from './center-content.component';
import { FlexModule } from '@angular/flex-layout';

@NgModule({
    declarations: [
        CenterContentComponent
    ],
    entryComponents: [
        CenterContentComponent
    ],
    exports: [
        CenterContentComponent
    ],
    imports: [
        CommonModule,
        AreaMenuItemModule,
        UserInfoModule,
        FlexModule
    ],
})
export class CenterContentModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            CenterContentComponent
        ]);
    }
}
